//#region [IMPORT]

// === THIRD-PARTY ===
import React from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from '@mui/material';

// === HOOKS ===
import { useAnalytics } from 'pages/DocAnalytics/AnalyticsContext/AnalyticsContext';

//#endregion

//-----------------------------------------------------------------
export default function ReviewStatusSelect(props) {
  //-----------------------------------------------------------------
  
  //#region [VALUES]

  const { review_flags, setReviewFlags, review_options } = useAnalytics();

  const options = [review_options.FAILED, review_options.PASSED, review_options.OVERRULED]

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onChange(event) {
    //-----------------------------------------------------------------
    const value = event.target.value;
    setReviewFlags( value || [] );
  };

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function render() {
    //-----------------------------------------------------------------
    return (
      <FormControl fullWidth size="small">
        <InputLabel>Show</InputLabel>

        <Select
          sx={{ width: '220px' }}
          multiple
          label="Show"
          value={review_flags}
          onChange={onChange}
          renderValue={renderValue}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              <Checkbox     checked={review_flags.includes(option.value)} />
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  //-----------------------------------------------------------------
  function renderValue( values_selected ) {
    //-----------------------------------------------------------------
    return options.filter( (option) => values_selected.includes(option.value) )
                  .map   ( (option) => option.label )
                  .join  ( ", " );
  }

  //#endregion

  return render();
}